// Corte de comunicación con LATAM durante el OrderChange: el resultado de la emisión/reemisión
// no está confirmado. El backend responde transactionStatusCode "2" con este código en errors.error[0].code.
export const COMMUNICATION_INTERRUPTED_CODE = "LATAM_ORDER_CHANGE_COMMUNICATION_INTERRUPTED";

export const PENDING_VERIFICATION_TITLE = "Emisión pendiente de verificación";
export const PENDING_VERIFICATION_MESSAGE = "Se interrumpió la comunicación con LATAM y no pudimos confirmar " +
    "si los boletos se emitieron. No vuelva a intentar la emisión. Contacte al counter para que verifique " +
    "con LATAM si los tickets fueron emitidos y le indique cómo continuar.";

// El estado "pendiente de verificación" vive solo en memoria (Redux + estado de la instancia de Checkout).

const normalize = (value) => `${value == null ? "" : value}`.trim();

const toList = (value) => {
    if (!value) {
        return [];
    }
    return Array.isArray(value) ? value : [value];
};

// Acepta la forma serializada por el backend (errors.error[]) y la forma OTA (Errors.Error).
const getResponseErrors = (data) => {
    const errors = data?.errors || data?.Errors;
    return toList(errors?.error || errors?.Error);
};

const getErrorCode = (error) => normalize(error?.code || error?.Code);

export const isCommunicationInterruptedResponse = (data) =>
    getResponseErrors(data).some(error => getErrorCode(error) === COMMUNICATION_INTERRUPTED_CODE);

export const getCommunicationInterruptedMessage = (data) => {
    const error = getResponseErrors(data).find(item => getErrorCode(item) === COMMUNICATION_INTERRUPTED_CODE);
    return normalize(error?.value || error?.Value);
};

// Datos que muestra el aviso; se construyen solo a partir de la respuesta de la remisión actual.
export const buildPendingVerificationNotice = (travelItineraryRS, backendMessage) => ({
    code: COMMUNICATION_INTERRUPTED_CODE,
    pnr: normalize(travelItineraryRS?.pnr).toUpperCase(),
    orderId: normalize(travelItineraryRS?.orderId),
    backendMessage: backendMessage || ""
});
